import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initInformation() {
  Alpine.data(
    'information',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        document.addEventListener('DOMContentLoaded', () => {
          // @ts-ignore
          const swiperEl = this.$el.querySelector('.sw-SlideOfEvents');
          if (swiperEl) {
            this.initSwiper(swiperEl as HTMLElement);
          }
        });
      },
      initSwiper(domEl) {
        const { size } = domEl.dataset;
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          spaceBetween: 0,
          centeredSlides: size === '1',
          slidesPerView: 1,
          autoHeight: true,
          autoplay: {
            delay: 2500,
            pauseOnMouseEnter: true,
            disableOnInteraction: true,
          },
          navigation: {
            nextEl: '.sw-SlideOfEvents__buttons .swiper-button-next',
            prevEl: '.sw-SlideOfEvents__buttons .swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
          },
        });
      },
    }),
  );
}
